export type LoyaltyReferralStatsProps = {
  heading: string;
  subHeading: string;
  friendsReferredDescription: string;
  friendsReferredInfoHeading: string;
  friendsReferredPoints: string;
  friendsReferredSubText: string;
  pointsEarnedDescription: string;
  pointsEarnedCtaLink: string;
  pointsEarnedCtaText: string;
  nextTierInfoDescription: string;
  nextTierInfoCtaLink: string;
  nextTierInfoCtaText: string;
  progressBlockBg: string;
  progressBlockBgTablet: string;
  progressBlockBgMobile: string;
  progressBlockHeading: string;
  progressBlockDescription: string;
  progressBlockHeadingAllDone: string;
  progressBlockDescriptionAllDone: string;
  progressBarText: string;
  milestonesText: string;
  achievementsDoneHeading: string;
  achievementsDoneText: string;
  isInEditor: boolean;
  theme?: "light" | "dark";
  isStatsVisible: boolean;
  isAnimatedNumberEnabled?: boolean;
};

export type SimplifiedMilestone = {
  referralNumber: number;
  mileStonePointsValue: number;
};
